import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-fund-annuity" }, null, -1)
const _hoisted_2 = { class: "col-md-9" }
const _hoisted_3 = { class: "fund-cover fund-cover__annuity d-flex align-items-start flex-column" }
const _hoisted_4 = { class: "fund-cover-header w-100" }
const _hoisted_5 = { class: "coverage-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fund-cover-row" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-dollar-square" }),
  /*#__PURE__*/_createElementVNode("p", { class: "links" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Principal Balance")
  ])
], -1)
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_9 = { class: "fund-cover-buttons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.principal.com/",
  target: "_blank",
  class: "btn btn-secondary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-principal" }),
  /*#__PURE__*/_createElementVNode("span", null, "Principal Login")
], -1)
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FundPanel = _resolveComponent("FundPanel")!

  return (_ctx.data.ENABLED)
    ? (_openBlock(), _createBlock(_component_FundPanel, {
        key: 0,
        cardId: "card-annuity"
      }, {
        icon: _withCtx(() => [
          _hoisted_1
        ]),
        title: _withCtx(() => [
          _createTextVNode(" Annuity ")
        ]),
        "fund-cover": _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.loading ? '...' : _ctx.balanceAmount), 1),
                    _createTextVNode(),
                    _createElementVNode("small", null, _toDisplayString(_ctx.loading ? '' :'(as of ' + _ctx.principalBalance?.accountEffectiveDate  + ')'), 1)
                  ])
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", {
                  href: "",
                  class: "btn btn-primary plan-modal",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('work-history', 'Annuity Work History', null, 'annuity', null, null, undefined, { Funds: [5, 7, 8]})), ["prevent"]))
                }, "Work History "),
                _hoisted_10
              ])
            ])
          ])
        ]),
        "related-links": _withCtx(() => [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('annuity-application', 'Annuity Application - Eligibility Determination Request', 'plan-form')), ["prevent"])),
            class: "btn btn-tertiary btn-large plan-modal"
          }, " Annuity Application"),
          _createElementVNode("a", {
            href: _ctx.salaryDeferralCupon,
            target: "_blank",
            class: "btn btn-tertiary btn-large"
          }, "Salary Deferral Coupon", 8, _hoisted_11),
          _createElementVNode("a", {
            href: "",
            class: "btn btn-tertiary btn-large plan-modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal(
                    'add-beneficiary',
                    'My Beneficiary(ies)',
                    'plan-tables-striped beneficiary',
                    null,
                    null,
                    null,
                )), ["prevent"]))
          }, " Beneficiary(ies) "),
          _createElementVNode("a", {
            href: "",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Annuity Fund Resources', null, 'annuity')), ["prevent"])),
            class: "btn btn-tertiary btn-large plan-modal"
          }, "Fund's Resources")
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}